import moment from 'moment';
import { Button } from 'react-bootstrap';
import styled, { useTheme } from 'styled-components';

import { useActiveSubscription, useManageSubscription } from '../../../hooks';
import BasicSpinner from '../../BasicSpinner';
import ErrorLabel from '../../ErrorLabel';
import ExternalLink from '../../Icon/ExternalLink';

import InformationPanel from './InformationPanel';

const StyledExternalLinkIcon = styled(ExternalLink)`
  position: relative;
  top: -2px;
  margin-left: 10px;
`;

const SubscriptionDetails = () => {
  const theme = useTheme();
  const { activeSubscription } = useActiveSubscription();
  const { onManageSubscription, redirecting, errorMessage } = useManageSubscription();

  const renewalTs = activeSubscription?.renewal_date ? Number(activeSubscription.renewal_date) * 1000 : null;
  const isExpired = renewalTs ? renewalTs < Date.now() : false;
  const dateLabel = isExpired ? 'Expired on' : 'Renews on';

  return (
    <InformationPanel title="Subscription details">
      <li>Subscription type: {activeSubscription?.subscription_name || '---'}</li>
      <li>
        {dateLabel}: {renewalTs ? moment(renewalTs).format('DD MMMM YYYY') : '---'}
      </li>
      <Button variant="secondary" className="pl-5 pr-5 mb-2" onClick={onManageSubscription}>
        Manage Subscription
        {!redirecting ? <StyledExternalLinkIcon colour={theme.colors.primary} /> : <BasicSpinner />}
      </Button>
      {!!errorMessage && <ErrorLabel label={errorMessage} />}
    </InformationPanel>
  );
};

export default SubscriptionDetails;
